import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

/**
 * ProtectedRoute — gates children behind authentication and optional role.
 *   <ProtectedRoute>            → any authenticated user
 *   <ProtectedRoute adminOnly>  → admin role only (403-style redirect to /)
 */
export default function ProtectedRoute({ children, adminOnly = false }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <div className="px-8 lg:px-14 pt-16 text-sm text-muted-foreground">Authenticating…</div>;
    }
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    if (adminOnly && user.role !== "admin") {
        // Send non-admins back to the Briefing
        return <Navigate to="/" replace />;
    }
    return children;
}
